// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/format.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/format.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo meal-planner-app
//     node fleet/fleet.ts check --repo meal-planner-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
const BYTES_PER_KB = 1024;
const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
const BYTES_PER_GB = BYTES_PER_MB * BYTES_PER_KB;
const BYTES_PER_TB = BYTES_PER_GB * BYTES_PER_KB;
const DECIMAL_PLACES_SMALL = 1;
const DECIMAL_PLACES_LARGE = 2;

/**
 * Formats a number of bytes into a human-readable string (B, KB, MB, GB, TB).
 *
 * GB/TB were added with the monetization kit: an academy's VOD quotas are
 * expressed in gigs, and cutting the scale off at MB forced you to read
 * "102400.00 MB" — or, worse, to write a second `formatBytes` in the kit.
 * One function, one place (a hard rule from `CLAUDE.md`).
 */
export function formatBytes(bytes: number | null): string {
  if (bytes === null) {
    return "–";
  }
  if (bytes < BYTES_PER_KB) {
    return `${bytes} B`;
  }
  if (bytes < BYTES_PER_MB) {
    return `${(bytes / BYTES_PER_KB).toFixed(DECIMAL_PLACES_SMALL)} KB`;
  }
  if (bytes < BYTES_PER_GB) {
    return `${(bytes / BYTES_PER_MB).toFixed(DECIMAL_PLACES_LARGE)} MB`;
  }
  if (bytes < BYTES_PER_TB) {
    return `${(bytes / BYTES_PER_GB).toFixed(DECIMAL_PLACES_LARGE)} GB`;
  }
  return `${(bytes / BYTES_PER_TB).toFixed(DECIMAL_PLACES_LARGE)} TB`;
}
